import React, { useEffect, useState } from "react";
import addresicon from "../../assets/images/address-1.svg";
import arrowLeft from "../../assets/images/arrow-leftttttt.svg";
import { useNavigate, useParams } from "react-router-dom";
import { jobService } from "services/job.service";
import { Offcanvas } from 'react-bootstrap';

import { getFormattedDate } from "utils";

import useCurrentUser from "hooks/useCurrentUser";
import RaseandDispute from "components/Modals/Clientpanelpipup/RaseandDispute";
import RatenReview from "components/Modals/Clientpanelpipup/RatenReview";
import star from "../../assets/images/star.svg";
import userimg from "../../assets/images/avatar.svg";
import msgActiveimg from "../../assets/images/msg-blue.svg";
import BidNowForm from "components/Modals/FormPopup/BidNowForm";
import { chatService } from "services/chat.service";
import BidList from "./BidList";
import { toast } from "react-toastify";
import SolarFiles from "components/Modals/Clientpanelpipup/SolarFiles";
import FolderDetail from "components/Modals/FolderDetail";
import ViewModal from "components/Modals/ViewModal";

const JobDetailsPage = () => {
  const { id } = useParams()

  const [show, setShow] = useState(false);
  const [showDispute, setShowDispute] = useState(false);
  const [viewFile, setViewFile] = useState(false)
  const [jobId, setJobId] = useState(false)
  const [reviewId, setReviewId] = useState(false)
  const [pilot, setPilotId] = useState('')
  const [data, setData] = useState([])
  const [showreview, setShowReview] = useState(false);
  const [showDisputeButton, setShowDisputeButton] = useState(true);
  const [folderId, setFolderId] = useState('')
  const [bidNowModal, setBidNowModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedFolderId, setSelectedFolderId] = useState(false)
  const [folderDetails, setFolderDetails] = useState({});
  const [showBidList, setshowBidList] = useState(false)
  const [showDetailModal, setShowDetailModal] = useState(false);
  const navigate = useNavigate();
  const { user } = useCurrentUser();

  const handleClose = () => {
    setShow(false)
    setShowReview(false)
    setShowDispute(false)
    setBidNowModal(false)
    setShowDetailModal(false)
    setViewFile(false);
    setshowBidList(false)
  };

  const handleCloseDispute = () => {
    setShow(false);
    setShowReview(false);
    setBidNowModal(false);
    setShowDispute(false);
  };

  const handleShow = () => {
    setJobId(id)
    setShowDispute(true)
  };

  const handleBidShow = (id) => {
    setBidNowModal(true);
    setSelectedJobId(id);
  }

  const ClientJobDetails = async () => {
    try {
      const response = await jobService.clientJobDetails(id);
      setData(response?.data?.data)
      setPilotId(response?.data?.data?.pilotId?._id)
      setJobId(response?.data?.data?._id)
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    ClientJobDetails()
  }, [])

  const handleBack = () => {
    navigate(-1);
  }

  const handleNavigate = (data) => {
    if (data?.length > 0) {
      const [lng, lat] = data;
      const googleMapsURL = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(googleMapsURL, '_blank');
    }
  }

  const handleShowBidModal = () => {
    setBidNowModal(true);
  }

  const handleCloseBidModal = () => {
    setBidNowModal(false);
  }

  const onChatClick = async (jobId, clientId, pilotId) => {
    try {
      const response = await chatService.startChat({ jobId, clientId, pilotId });
      navigate(`/chat?id=${response?.data?.data?._id}`)
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  const handleDownLoad = async () => {
    try {
      const response = await jobService.DownloadReport(id)
      if (response?.data?.data?.url) {

        fetch(response?.data?.data?.url).then(
          (response) => {
            response.blob().then((blob) => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = "report.pdf";
              alink.click();
            });
          }
        );
      }
    }
    catch (err) {
      console.log(err?.response?.data?.message)
    }
  }

  return (
    <>
      <div className="container-box">
        <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2>
            <img src={arrowLeft} className="me-3 cursor-pointer" onClick={handleBack} alt="" />Job Details
          </h2>
          {user?.roleType === "CLIENT" && data?.status === 'Completed' ? (<>
            <div className="d-flex gap-3">

              {data?.isDisputed ? <></> : <button className="border-0  rounded-3 px-3 py-2 bg-cyan" onClick={handleShow}> Raise a Dispute</button>}
              <RaseandDispute show={showDispute} handleClose={handleCloseDispute} id={jobId} setJobDetails={setData} jobDetails={data} />
              {data?.reviewId ? null : (<>
                <button className="border-0  rounded-3 px-3 py-2 bg-cyan" onClick={() => {
                  setShowReview(true)
                  setReviewId(data?.reviewId)
                }}> Rate & Review</button>
                {showreview &&
                  <RatenReview show={showreview} handleClose={handleClose} pilotId={pilot} jobId={jobId} setJobDetails={setData} />
                }
              </>)}

            </div>
          </>) : null}
        </div>
        <div className="outer-white job-details-page px-3">
          <div className="row">
            <div className="col">
              <div>
                <div className="d-flex justify-content-between align-items-center gap-2">
                  <div className="d-flex align-items-center gap-1">
                    {user?.roleType === 'PILOT' ? (
                      <>
                        <img
                          alt="avatar"
                          src={
                            data?.clientId?.avatar
                              ? `${user?.baseS3Url}${data?.clientId?.avatar}`
                              : userimg
                          }
                          onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = userimg;
                          }}
                          className="round-img border border-secondary"
                        />
                        <p className="mb-0 dark-textss ms-2">{data?.clientId?.fullName}</p>
                      </>
                    ) : (
                      <>
                        {data?.status !== 'Pending' && (
                          <>
                            <img
                              alt="avatar"
                              src={
                                data?.pilotId?.avatar
                                  ? `${user?.baseS3Url}${data?.pilotId?.avatar}`
                                  : userimg
                              }
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop
                                e.target.src = userimg;  // Fallback image
                              }}
                              className="round-img border border-secondary"
                            />
                            <p className="mb-0 dark-textss ms-2">{data?.pilotId?.fullName}</p>
                          </>
                        )}
                        {data?.status === "Completed" && (
                          <>
                            {data?.pilotId?.totalRating > 0 && <p className="mb-0">
                              <img src={star} className="me-2" />{Math.round(data?.pilotId?.avgRating)} Rating
                            </p>}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {data?.status !== 'Pending' && <img alt="" src={msgActiveimg} className="msg-v"
                    onClick={() => onChatClick(data?._id, data?.clientId?._id, data?.pilotId?._id)}
                  />}
                </div>
                <div className="d-flex justify-content-between gap-2 align-items-center">
                </div>
                <div className="d-flex justify-content-between flex-wrap gap-2">
                  <h3>{data?.title}</h3>
                  <div className="d-flex mt-4 mb-4 align-items-center gap-2">
                  </div>
                  {user.roleType === 'CLIENT' && (data?.totalBids > 0 && data?.status === "Pending" ? (
                    <div>
                      <p className="mb-0 otp-bedge" onClick={() => {
                        setshowBidList(true);
                      }}>
                        {data?.totalBids} {data?.totalBids > 1 ? 'Bids' : 'Bid'}
                      </p>
                    </div>
                  ) : (
                    <>{data?.status === "Pending" && <p className="pending-bedge mt-2">{data?.status}</p>}</>
                  ))}
                </div>
                <div>
                  <div className="details-para cursor-pointer" onClick={() => handleNavigate(data?.coordinates)}>
                    <h6 className="light-texts">Destination</h6>
                    <p>
                      {data?.address}
                      <img src={addresicon} className="ms-2" alt="" />
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <div>
                            <p className="light-texts">Required Date</p>
                            <p className="dark-textss">{getFormattedDate(data?.requiredDate)}</p>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div>
                            <p className="light-texts">Area Size ({data?.areaUnit?.toLowerCase()})</p>
                            <p className="dark-textss">{data.areaSize}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4 mt-4">
                  <h6 className="light-texts">Specialized</h6>
                  <div className="d-flex gap-2 flex-wrap">
                    {data?.specialisedId?.map((item, i) => {
                      return <>
                        <span className="blue-bedge">{item?.title}</span>
                      </>
                    })}
                  </div>
                </div>
                <div className="details-para">
                  <h6 className="light-texts">Instruction</h6>

                  <p>
                    {data?.instructions}
                  </p>

                </div>
                <div className="details-para">
                  <h6 className="light-texts">Description</h6>

                  <p>
                    {data?.description}
                  </p>

                </div>

                <div className="d-flex flex-wrap justify-content-between">
                  <div className="d-flex gap-3 amount-div">
                    {data?.jobFinalCost && (
                      <>
                        <h5 >Final Approved Amount ($)</h5>
                        <p>{data?.jobFinalCost}</p>
                      </>
                    )}
                  </div>
                  {data?.status === 'Completed' && (
                    <div className="d-flex  justify-content-between footer-btns gap-2">
                      {user?.roleType === 'CLIENT' ?
                        (<>
                          <button type="submit" className="btn btn-primary mr-4" onClick={() => {
                            setSelectedFolderId(data?.folderId)
                            setShow(true)
                          }}> View Files</button>
                          <SolarFiles show={show} setShow={setShow} handleClose={handleClose}
                            id={selectedFolderId}
                            setFolderDetails={setFolderDetails}
                            setShowDetailModal={setShowDetailModal}
                          />
                        </>) :
                        (<>
                          <button type="submit" className="btn btn-primary" onClick={() => {
                            setViewFile(true)
                            setFolderId(data?.folderId)
                          }
                          }>
                            View Files
                          </button>
                        </>)
                      }
                      {showDetailModal && <FolderDetail show={showDetailModal} setShow={setShowDetailModal} folder={folderDetails} setFolder={setFolderDetails} />}
                      <button onClick={handleDownLoad} className="btn btn-primary" >
                        Download Report
                      </button>
                    </div>
                  )}
                  {user?.roleType === 'PILOT' && !data?.bidPilots?.includes(user?._id) && <div className="d-flex flex-wrap gap-2">
                    <button onClick={handleShowBidModal} className="btn btn-primary">
                      Bid Now
                    </button>
                  </div>}


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Offcanvas
        show={showBidList}
        onHide={handleClose}
        backdrop="static"
        placement="end"
        className="bid-request-modal-client"
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body className="bid-request-modal p-0">
          <BidList id={id} setShowBids={setshowBidList} />
        </Offcanvas.Body>
      </Offcanvas >
      <ViewModal show={viewFile} handleClose={handleClose} folderId={folderId} />
      <BidNowForm
        show={bidNowModal}
        handleClose={handleCloseBidModal}
        selectedJobId={data?._id}
      />
    </>
  );
};

export default JobDetailsPage;